import { EmitService } from './../../../../core/services/utils/emit.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-pregunta',
  templateUrl: './modal-pregunta.component.html',
  styleUrls: ['./modal-pregunta.component.css']
})
export class ModalPreguntaComponent implements OnInit {

  constructor(
    private modalService: ModalService,
    private emit: EmitService
  ) { }

  ngOnInit(): void {
  }

  cerrar(){
    this.modalService.closeModal();
  }

  confirmar(){
    this.emit.enviarLogin('confirmar');
    this.cerrar();
  }

}
